var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("loading", {
        attrs: { active: _vm.isLoaderVisible },
        on: {
          "update:active": function($event) {
            _vm.isLoaderVisible = $event
          }
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c(
          "label",
          {
            staticClass: "col-sm-2 control-label",
            attrs: { for: "isMarketingEvent" }
          },
          [_vm._v("\n            Marketing to?:\n        ")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-6" }, [
          _c("div", { staticClass: "radio" }, [
            _c(
              "label",
              {
                staticClass: "radio-inline",
                attrs: { for: "attachInvoiceYes" }
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.timeEntry.isMarketingEvent,
                      expression: "timeEntry.isMarketingEvent"
                    }
                  ],
                  attrs: {
                    type: "radio",
                    name: "isMarketingEvent",
                    id: "marketingEventNo",
                    value: "No",
                    disabled: _vm.timeEntry.isAuditEdit
                  },
                  domProps: {
                    checked: _vm._q(_vm.timeEntry.isMarketingEvent, "No")
                  },
                  on: {
                    change: [
                      function($event) {
                        return _vm.$set(_vm.timeEntry, "isMarketingEvent", "No")
                      },
                      function($event) {
                        return _vm.clearContact()
                      }
                    ]
                  }
                }),
                _vm._v(
                  "\n                    Contact/Company\n                "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "radio-inline",
                attrs: { for: "attachInvoiceNo" }
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.timeEntry.isMarketingEvent,
                      expression: "timeEntry.isMarketingEvent"
                    }
                  ],
                  attrs: {
                    type: "radio",
                    name: "isMarketingEvent",
                    id: "attachInvoiceYes",
                    value: "Yes",
                    disabled: _vm.timeEntry.isAuditEdit
                  },
                  domProps: {
                    checked: _vm._q(_vm.timeEntry.isMarketingEvent, "Yes")
                  },
                  on: {
                    change: [
                      function($event) {
                        return _vm.$set(
                          _vm.timeEntry,
                          "isMarketingEvent",
                          "Yes"
                        )
                      },
                      function($event) {
                        return _vm.setMarketingEvent()
                      }
                    ]
                  }
                }),
                _vm._v("\n                    An Event\n                ")
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.timeEntry.isMarketingEvent === "No"
        ? _c("div", { staticClass: "form-group" }, [
            _c(
              "label",
              {
                staticClass: "col-sm-2 control-label",
                attrs: { for: "fileId" }
              },
              [_vm._v("\n            Who:\n        ")]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-sm-10 col-md-8 col-lg-6" },
              [
                _vm.timeEntry.marketingLocationId > 0
                  ? [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.timeEntry.marketingContactLabel) +
                          "\n                "
                      ),
                      _c(
                        "a",
                        {
                          staticClass: "btn btn-link change",
                          attrs: { id: "MarketingContactPicker" },
                          on: {
                            click: function($event) {
                              return _vm.pickContact(_vm.pickerUrl)
                            }
                          }
                        },
                        [_vm._v("Change Contact")]
                      )
                    ]
                  : [
                      _c(
                        "a",
                        {
                          staticClass: "btn btn-link",
                          attrs: { id: "MarketingContactPicker" },
                          on: {
                            click: function($event) {
                              return _vm.pickContact(_vm.pickerUrl)
                            }
                          }
                        },
                        [_vm._v("Choose Contact")]
                      )
                    ],
                _vm._v(" "),
                _vm.errors.has("marketingLocationId")
                  ? _c("p", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(_vm.errors.first("marketingLocationId")))
                    ])
                  : _vm._e()
              ],
              2
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d73e490", { render: render, staticRenderFns: staticRenderFns })
  }
}